import React from 'react'
import { RenderControl } from '@fareye/ui'
import {
  isEmpty,
  cancelToken,
  getQueryParams,
  get,
  responseParser
} from '@fareye/utils'
import { mapping } from '../../../config/mapComponents'
import { IRouteWisePerformance } from '../../../utility/types'
import { RouteContainerGrid } from '../../../style/styled'

const RouteWisePerformance = ({
  match,
  config,
  history,
  endDate,
  location,
  startDate,
  searchQuery,
  setSummaryFilter
}: IRouteWisePerformance) => {
  const source = cancelToken().source()
  const {
    config: { apiConfig },
    styling,
    children
  } = config
  const { style, className } = styling
  const compName: any = (children as any).component
  const Component = children && (mapping as any)[compName]
  const [apiResponse, setApiResponse] = React.useState({
    data: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
  })
  const query = getQueryParams({
    startDate,
    endDate,
    ...searchQuery,
    ...(apiConfig && apiConfig.queryParams)
  })
  async function fetchData() {
    try {
      setApiResponse({ ...apiResponse, isLoading: true })
      setSummaryFilter([])
      const {
        data: { content, content_summary },
        message,
        error
      } = responseParser(
        await get(`${apiConfig && apiConfig.apiURL}?${query}`, source.token)
      )
      setSummaryFilter(content_summary ? content_summary : [])
      setApiResponse({
        ...apiResponse,
        isError: error,
        data: error ? content : content ? content : {}, // FIXME: Weird should be []
        isSuccess: true,
        isLoading: false,
        message: error
          ? message
          : isEmpty(content)
          ? apiConfig && apiConfig.apiDataState
            ? apiConfig.apiDataState.noDataMessage
            : 'No Data Found'
          : ''
      })
    } catch (err:any) {
      const { message, error } = responseParser(err.response)
      setApiResponse({
        ...apiResponse,
        isSuccess: false,
        isError: true,
        isLoading: false,
        message
      })
      console.error('App Error:', error)
    }
  }

  React.useEffect(() => {
    fetchData()
    return () => {
      source.cancel('Unsubscribe Before Unmount')
    }
    // eslint-disable-line
  }, [query])

  const { data } = apiResponse
  const hasContent = !isEmpty(data)
  const transporterData = hasContent ? data[0]['data'] : []

  return (
    <RenderControl state={apiResponse} variant={'l'}>
      <RouteContainerGrid style={style} className={className}>
        {transporterData
          .sort((a: any, b: any) => {
            return a.totalTrips > b.totalTrips ? -1 : 1
          })
          .map((item: any, index: number) => (
            <Component
              {...item}
              match={match}
              history={history}
              endDate={endDate}
              location={location}
              startDate={startDate}
              key={`TransportersDetailsCard${index}`}
              config={config.children}
            />
          ))}
      </RouteContainerGrid>
    </RenderControl>
  )
}

export default RouteWisePerformance
